import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, handleDateChange, initializeFilterData } from "../CommonComponents/CustomHooks";
import { CommonApiData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, InputBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";
import { GetSession } from "../CommonComponents/cryptoUtils";

const SaleReport = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    const [result, setResult] = useState({ Data: [] });
    const [loading, setLoading] = useState(false);
    const [filterData, setFilterData] = useState(initializeFilterData);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const inputrefs = useRef([]);
    const commonData = CommonApiData();
    const LoginType = GetSession('cookies', 'loginUserType');
    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
    };
    const [formData, setFormData] = useState({
        ...Data,
        "fromDate": dateArr,
        "toDate": dateArr,
        "dealer": "",
        "mobileNo": "",
        "invoiceNo": "",
        "IMEI": "",
        "ProductCode": ""
    })


    const handleChange1 = (event, value) => {
        GetSaleReport(value);
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleClear = async () => {
        await setFormData({
            ...Data,
            "fromDate": dateArr,
            "toDate": dateArr,
            "dealer": "",
            "mobileNo": "",
            "invoiceNo": "",
            "IMEI": "",
            "ProductCode": ""
        })
        await inputrefs.current['txtFromDate'].focus()
        await setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const GetSaleReport = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...Data,
            loginUserType: LoginType,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        await (setLoading(true))
        let data = await ApiCall('/api/Report/DealerSaleReport', GetData)
        await (setLoading(false))
        if (data.Status === 'UNAUTHORIZED' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message);
        } else {
            setResult(data)
        }
        await (setLoading(false))
    }

    let ExportRequest = {
        ...Data,
        ...formData,
        ...filterData,
        loginUserType: LoginType,
        Type: 'E',
        sortConfig,
        PageIndex: '1'
    }


    useEffect(() => {
        GetSaleReport();
        inputrefs.current['txtFromDate'].focus()
        document.title = 'Sale Report'
    }, [sortConfig]);

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'Sale Report'}</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <DateBox
                            id='txtFromDate'
                            inputrefs={inputrefs}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLogDateTo'].focus() };
                            }}

                        />
                        <DateBox
                            id='txtLogDateTo'
                            inputrefs={inputrefs}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    if (LoginType === 'Admin') {
                                        inputrefs.current['txtDealer'].focus();
                                    } else {
                                        inputrefs.current['txtMobileNo'].focus();
                                    }
                                }
                            }}
                        />
                        {LoginType === "Admin" && (
                            <AutoCompleteBoxNew
                                id="txtDealer"
                                placeholder="Dealer"
                                label={'Dealer'}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtMobileNo'].focus()
                                    }
                                }}
                                contextKey={formData.dealer}
                                autocompleteType='GetDealerMaster'
                                value={formData.dealer || ''}
                                onChange={async (event, newInputValue) => {
                                    newInputValue = newInputValue || ''
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, dealer: newInputValue })
                                    }
                                }}
                                maxLength='50'
                            />
                        )}
                        <InputBox
                            label='Mobile No'
                            placeholder='Mobile No'
                            inputrefs={inputrefs}
                            id='txtMobileNo'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtInvoice'].focus() };
                            }}
                            value={formData.mobileNo}
                            onChange={(e) => setFormData({ ...formData, mobileNo: e.target.value })}
                            autoComplete="off"
                        />
                        <InputBox
                            label='Invoice No'
                            placeholder='Invoice No'
                            inputrefs={inputrefs}
                            id='txtInvoice'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtIMEINo'].focus() };
                            }}
                            value={formData.invoiceNo}
                            onChange={(e) => setFormData({ ...formData, invoiceNo: e.target.value })}
                            autoComplete="off"
                        />
                        <InputBox
                            label='IMEI No'
                            placeholder='IMEI No'
                            inputrefs={inputrefs}
                            id='txtIMEINo'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtProductCode'].focus() };
                            }}
                            value={formData.IMEI}
                            onChange={(e) => setFormData({ ...formData, IMEI: e.target.value })}
                            autoComplete="off"
                        />
                        <AutoCompleteBoxNew
                            id="txtProductCode"
                            placeholder="Product"
                            label={'Product'}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtbtn'].focus()
                                }
                            }}
                            autocompleteType='GetProductCode'
                            value={formData.ProductCode || ''}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setFormData({ ...formData, ProductCode: newInputValue })
                                }
                            }}
                            maxLength='50'
                        />
                    </div>
                    <div className='d-block mt-3 d-md-flex' >
                        <button
                            ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                            onClick={GetSaleReport}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                                <i className="fa fa-search"></i>
                            </span>Search</button>
                        <button
                            className="btn btn-rounded btn-warning"
                            onClick={async () => {
                                try {
                                    dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Report/DealerSaleReport', ExportRequest, 'Sale Report');
                                    dispatch(setSubLoading(false))
                                }
                                finally { dispatch(setSubLoading(false)) }
                            }} >
                            <span className="text-warning me-2">
                                <i className="fa fa-download text-white color-success"></i>
                            </span>
                            Export
                        </button>
                        <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                        </span>Reset</button>
                    </div>
                </div>
            </div>

            <Table
                PageName={"SaleReport"}
                loading={loading}
                handleFilter={() => {
                    GetSaleReport()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                setFilterData={setFilterData}
                tableData={result}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                Filter={false}
                onlyFilterPage={true}
            />

        </>
    )
}
export default SaleReport;